<p-dialog
  [visible]="blockClientBookingModal()"
  [modal]="true"
  [style]="{ width: '30vw' }"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
  [draggable]="true"
  [resizable]="true"
  appendTo="body"
  (onHide)="closeDialogEvent()"
  aria-label="block-client-booking-dialog"
>
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-2">
      <i class="fa fa-ban text-xl text-primary" aria-hidden="true"></i>
      <span class="font-semibold text-lg">
        {{ 'CLIENT_PROFILE.BLOCK_CLIENT_BOOKING.TITLE' | translate }}
      </span>
    </div>
  </ng-template>

  <div class="p-3">
    <form [formGroup]="blockClientBookingFormGroup">
      <!-- Client Info -->
      <div
        class="flex align-items-center gap-3 mb-4 p-3 surface-100 border-round"
      >
        <p-avatar
          [label]="allClientData?.full_name | shortName"
          [image]="allClientData?.image"
          shape="circle"
          size="large"
          styleClass="text-lg"
          aria-label="client-avatar"
        />
        <div>
          <div class="font-semibold text-900">
            {{ allClientData?.full_name }}
          </div>
          <div class="text-sm text-600">{{ allClientData?.email_id }}</div>
        </div>
      </div>

      <!-- Block Until Date -->
      <div class="field mb-4">
        <label class="font-medium text-700 text-sm mb-2 block">
          {{
            'CLIENT_PROFILE.BLOCK_CLIENT_BOOKING.BLOCK_UNTIL_DATE' | translate
          }}
          <span class="text-red-400">*</span>
        </label>
        <p-datepicker
          formControlName="blockUntilDate"
          [showIcon]="true"
          [appendTo]="'body'"
          [autofocus]="false"
          icon="fa fa-calendar"
          placeholder="{{
            'CLIENT_PROFILE.BLOCK_CLIENT_BOOKING.SELECT_DATE' | translate
          }}"
          styleClass="w-full"
          inputStyleClass="text-sm"
          [minDate]="minDate"
          [showTime]="false"
          dateFormat="dd/mm/yy"
          aria-label="block-until-date-picker"
          data-testid="block-until-date-picker"
        />
        @if (BlockUntilDate.touched && BlockUntilDate.invalid) {
          <app-error-msg
            [errors]="BlockUntilDate.errors"
            [fieldLabel]="
              'CLIENT_PROFILE.BLOCK_CLIENT_BOOKING.BLOCK_UNTIL_DATE' | translate
            "
            data-testid="block-until-date-error"
          />
        }
      </div>

      <!-- Info Message -->
      <div class="p-3 surface-100 border-round border-left-3 border-primary">
        <div class="flex align-items-start gap-2">
          <i class="fa fa-info-circle text-primary mt-1" aria-hidden="true"></i>
          <div class="text-sm text-700">
            {{ 'CLIENT_PROFILE.BLOCK_CLIENT_BOOKING.INFO_MESSAGE' | translate }}
          </div>
        </div>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <button
        pButton
        pRipple
        type="button"
        [label]="'CLIENT_PROFILE.CANCEL' | translate"
        class="p-button-outlined p-button-secondary"
        (click)="closeDialogEvent()"
        [disabled]="btnLoading"
        aria-label="cancel-button"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        [label]="'CLIENT_PROFILE.BLOCK_CLIENT_BOOKING.BLOCK_BUTTON' | translate"
        class="p-button-danger"
        (click)="blockClientBooking()"
        [loading]="btnLoading"
        aria-label="block-booking-button"
      ></button>
    </div>
  </ng-template>
</p-dialog>
